import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/app/[lang]/contact/UserContactForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout","ContentContainer","Heading","TP","Stack","ContactDetails","ContactCards","ContactArea","Contact","ContactMail","Address","FilledImageCard"] */ "/root/lp-frontend/src/components/molecules/index.jsx");
